import { useEffect, useState } from "react";
import moment from "moment";
import { ResponsiveLine } from "@nivo/line";

export default function LineGraphic({ data, isLoading }) {
  const [jsonSata, setJsonSata] = useState({ id: "ventas", data: [] });

  useEffect(() => {
    setJsonSata({
      id: "ventas",
      data: data.map((point) => {
        point.date = moment(point.x).format("ll");
        point.x = moment(point.x).format("h:mm A");

        return point;
      })
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) return <div>Loading...</div>;

  return (
    <ResponsiveLine
      data={[jsonSata]}
      colors={{ scheme: "category10" }}
      margin={{
        top: 5,
        right: 10,
        bottom: 50,
        left: 50
      }}
      yScale={{
        type: "linear",
        stacked: true,
        min: "auto",
        max: "auto"
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: "bottom",
        tickSize: 0,
        tickPadding: 10,
        tickRotation: -65,
        legendOffset: 45,
        legend: "Hora concurrida",
        legendPosition: "middle"
      }}
      axisLeft={{
        orient: "left",
        tickSize: 0,
        tickPadding: 16,
        tickRotation: 0,
        legendOffset: -45,
        legendPosition: "middle",
        legend: "Nro de asistentes"
      }}
      curve="linear"
      enableGridX={false}
      pointSize={8}
      pointColor="#ffffff"
      pointBorderWidth={1}
      pointBorderColor={{ from: "serieColor", modifiers: [] }}
      pointLabelYOffset={-12}
      useMesh
      tooltip={(value) => (
        <div className="customTootip">
          <span>
            {value.point.data.y} asistentes a las {value.point.data.x}
          </span>
        </div>
      )}
    />
  );
}
